export enum Currency {
  'EUR' = 'EUR',
  'DKK' = 'DKK',
  'SEK' = 'SEK',
}

export enum Locale {
  'de' = 'de',
  'da' = 'da',
  'en' = 'en',
  'sv' = 'sv',
  'nl' = 'nl',
}

export enum Country {
  'DE' = 'DE',
  'DK' = 'DK',
  'SE' = 'SE',
  'NL' = 'NL',
}
